/**
 * History Keyboard Navigation — ArrowUp/Down/Left/Right, Tab, PgUp/PgDn, Enter, Esc
 * Depends on dropdown.js (window._historyDropdown) for shared state.
 * # ⛓️ CURSOR_ANCHOR:search:history-keyboard
 */
(function() {
  /**
   * Attach keyboard navigation (keydown) and input filter (input) listeners
   * to the search input for the history dropdown.
   */
  function setupKeyboardNavigation(searchInput) {
    var ds = window._historyDropdown;
    if (!ds) {
      console.warn('[HISTORY] _historyDropdown not loaded, keyboard navigation disabled');
      return;
    }
    var state = ds.state;
    var originalSearchText = '';

    // Quick filter on input change
    searchInput.addEventListener('input', function() {
      if (state.dropdown && state.dropdown.classList.contains('active')) {
        ds.resetHistorySelection();
        if (typeof filterHistoryItems === 'function') {
          filterHistoryItems(this.value);
        } else if (window.filterHistoryItems) {
          window.filterHistoryItems(this.value);
        }
      }
    });

    // Main keydown handler
    searchInput.addEventListener('keydown', function(e) {
      var dropdown = state.dropdown;
      if (!dropdown) return;

      // Ignore history nav when Shift or Ctrl held (standard browser actions)
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'PageDown' || e.key === 'PageUp') {
        if (e.shiftKey || e.ctrlKey) return;
      }

      // ArrowDown on closed dropdown -> open it
      if (e.key === 'ArrowDown') {
        if (!dropdown.classList.contains('active')) {
          e.preventDefault();
          ds.openHistoryDropdown();
          return;
        }
      }

      if (!dropdown.classList.contains('active')) return;

      var visibleItems = getVisibleItems(dropdown);
      if (visibleItems.length === 0) return;

      if (e.key === 'Tab') {
        handleTab(e, visibleItems, searchInput, state, originalSearchText, dropdown);
      } else if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (state.selectedIndex === -1) {
          originalSearchText = searchInput.value;
          var highlighted = dropdown.querySelector('.search-history-item.selected');
          state.selectedIndex = highlighted ? visibleItems.indexOf(highlighted) : 0;
        } else if (state.selectedIndex < visibleItems.length - 1) {
          state.selectedIndex++;
        }
        updateVisualSelection(visibleItems, true, state, searchInput);

      } else if (e.key === 'ArrowUp') {
        if (state.selectedIndex >= 0) {
          e.preventDefault();
          state.selectedIndex--;
          if (state.selectedIndex === -1) {
            updateVisualSelection(visibleItems, false, state, searchInput);
            searchInput.value = originalSearchText;
          } else {
            updateVisualSelection(visibleItems, true, state, searchInput);
          }
        } else {
          var highlighted = dropdown.querySelector('.search-history-item.selected');
          if (highlighted) {
            e.preventDefault();
            state.selectedIndex = visibleItems.indexOf(highlighted);
            updateVisualSelection(visibleItems, true, state, searchInput);
          }
        }

      } else if (e.key === 'ArrowLeft') {
        handleArrowLeft(e, visibleItems, state, dropdown, searchInput);

      } else if (e.key === 'ArrowRight') {
        handleArrowRight(e, visibleItems, state);

      } else if (e.key === 'PageDown') {
        e.preventDefault();
        if (state.selectedIndex === -1) originalSearchText = searchInput.value;
        state.selectedIndex = Math.min(state.selectedIndex + 5, visibleItems.length - 1);
        updateVisualSelection(visibleItems, true, state, searchInput);

      } else if (e.key === 'PageUp') {
        e.preventDefault();
        state.selectedIndex = Math.max(state.selectedIndex - 5, -1);
        if (state.selectedIndex === -1) {
          updateVisualSelection(visibleItems, false, state, searchInput);
          searchInput.value = originalSearchText;
        } else {
          updateVisualSelection(visibleItems, true, state, searchInput);
        }

      } else if (e.key === 'Enter') {
        if (state.selectedIndex >= 0 && state.selectedIndex < visibleItems.length) {
          e.preventDefault();
          state.lastSelectedTerm = visibleItems[state.selectedIndex].getAttribute('data-term');
          state.lastSelectedHistoryId = visibleItems[state.selectedIndex].getAttribute('data-id') || null;
          state.lastSelectedIndex = state.selectedIndex;
          visibleItems[state.selectedIndex].click();
        }

      } else if (e.key === 'Escape') {
        e.preventDefault();
        if (state.selectedIndex !== -1) {
          searchInput.value = originalSearchText;
        }
        ds.closeHistoryDropdown();
      }
    });
  }

  // --- Helper functions ---

  function getVisibleItems(dropdown) {
    return Array.from(dropdown.querySelectorAll('.search-history-item')).filter(function(item) {
      if (item.classList.contains('branch-hidden')) return false;
      return item.style.display !== 'none';
    });
  }

  function handleTab(e, visibleItems, searchInput, state, originalSearchText, dropdown) {
    if (e.shiftKey) {
      // Shift+Tab -> Up
      if (state.selectedIndex === -1) {
        var highlighted = dropdown.querySelector('.search-history-item.selected');
        if (highlighted) {
          e.preventDefault();
          state.selectedIndex = visibleItems.indexOf(highlighted);
          updateVisualSelection(visibleItems, true, state, searchInput);
        }
      } else if (state.selectedIndex >= 0) {
        e.preventDefault();
        state.selectedIndex--;
        if (state.selectedIndex === -1) {
          updateVisualSelection(visibleItems, false, state, searchInput);
          searchInput.value = originalSearchText;
        } else {
          updateVisualSelection(visibleItems, true, state, searchInput);
        }
      }
    } else {
      // Tab -> Down
      if (state.selectedIndex === -1) {
        var highlighted = dropdown.querySelector('.search-history-item.selected');
        if (highlighted) {
          e.preventDefault();
          state.selectedIndex = visibleItems.indexOf(highlighted);
          updateVisualSelection(visibleItems, true, state, searchInput);
        }
      } else if (state.selectedIndex < visibleItems.length - 1) {
        e.preventDefault();
        state.selectedIndex++;
        updateVisualSelection(visibleItems, true, state, searchInput);
      } else {
        // From last item, return to input
        e.preventDefault();
        state.selectedIndex = -1;
        updateVisualSelection(visibleItems, false, state, searchInput);
        searchInput.value = originalSearchText;
      }
    }
  }

  /**
   * ArrowLeft on selected item:
   *   - child -> jump to parent
   *   - expanded root -> collapse branch
   */
  function handleArrowLeft(e, visibleItems, state, dropdown, searchInput) {
    if (state.selectedIndex < 0 || state.selectedIndex >= visibleItems.length) return;
    var curItem = visibleItems[state.selectedIndex];
    var parentId = curItem.getAttribute('data-parent-id');
    if (parentId) {
      e.preventDefault();
      var parentEl = dropdown.querySelector('.search-history-item[data-id="' + parentId + '"]');
      if (parentEl) {
        var parentIdx = visibleItems.indexOf(parentEl);
        if (parentIdx >= 0) {
          state.selectedIndex = parentIdx;
          updateVisualSelection(visibleItems, true, state, searchInput);
        }
      }
    } else if (curItem.classList.contains('is-root') && curItem.classList.contains('has-children') && !curItem.classList.contains('branch-collapsed')) {
      e.preventDefault();
      var toggleBtn = curItem.querySelector('.search-history-toggle');
      if (toggleBtn) toggleBtn.click();
    }
  }

  /** ArrowRight on collapsed root -> expand branch. */
  function handleArrowRight(e, visibleItems, state) {
    if (state.selectedIndex < 0 || state.selectedIndex >= visibleItems.length) return;
    var curItem = visibleItems[state.selectedIndex];
    if (curItem.classList.contains('is-root') && curItem.classList.contains('has-children') && curItem.classList.contains('branch-collapsed')) {
      e.preventDefault();
      var toggleBtn = curItem.querySelector('.search-history-toggle');
      if (toggleBtn) toggleBtn.click();
    }
  }

  /** Visually highlight the selected item and optionally update input value. */
  function updateVisualSelection(items, updateInput, state, searchInput) {
    items.forEach(function(item, index) {
      if (index === state.selectedIndex) {
        item.classList.add('selected');

        state.lastSelectedIndex = index;
        state.lastSelectedTerm = item.getAttribute('data-term');
        state.lastSelectedHistoryId = item.getAttribute('data-id') || null;

        if (updateInput && searchInput) {
          var term = state.lastSelectedTerm;
          if (term) searchInput.value = term;
        }
        item.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      } else if (state.selectedIndex !== -1) {
        item.classList.remove('selected');
      }
    });
  }

  // Module export
  window._historyKeyboard = {
    setupKeyboardNavigation: setupKeyboardNavigation
  };
})();
